import {NoticeList, SnackbarList} from '@wordpress/components';
import { store as noticesStore } from '@wordpress/notices';
import { useDispatch, useSelect } from '@wordpress/data';

export function Notices() {
  const notices = useSelect(
      ( select ) => select( noticesStore ).getNotices(),
      []
  );
  const { removeNotice } = useDispatch( noticesStore );
  const snackbarNotices = notices?.filter( ({ type }) => type === 'default' ) ?? [];

  return (
      <NoticeList
          notices={ snackbarNotices }
          className="components-editor-notices__snackbar"
          onRemove={ removeNotice }
      />
  );
}